export const httpMethod = {
  get: 'get' as const,
  delete: 'delete' as const,
  post: 'post' as const,
  put: 'put' as const,
  patch: 'patch' as const,
};
